import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './MainSideBar.css';

function NavItem({ item, previousMenusOpen, menuItem }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [menusOpen, setMenusOpen] = useState([]);
    const [closing, setClosing] = useState('');

    const goTo = (path) => {
        navigate(path);
    };

    const handleOpenSubmenu = (event, navItemId, hasChildren, path) => {
        event.stopPropagation();

        if (!hasChildren) {
            goTo(path);
            return;
        }

        const isOpened = menusOpen.some((menuId) => menuId === navItemId);

        if (isOpened) {
            setClosing(navItemId);

            setTimeout(() => {
                setMenusOpen((prev) =>
                    prev.filter((menuId) => menuId !== navItemId)
                );
                setClosing('');
            }, 200);
        } else {
            setMenusOpen((prev) => [...prev, navItemId]);
        }
    };

    useEffect(() => {
        setMenusOpen((prev) => [...prev, ...previousMenusOpen]);
    }, [previousMenusOpen]);

    const setCurrentPage = (path) => {
        return localStorage.setItem('page', path);
    };

    const CURRENT_PAGE = localStorage.getItem('page') || location.pathname;

    useEffect(() => {
        setCurrentPage(location.pathname);
    }, [location]);

    const findMenuItem = (menu, item) => {
        return menu?.find((menuItem) => menuItem._id === item._id);
    };

    function renderNavItem(navItem, menuItem, depth = 1) {
        const isOpened = menusOpen.some((menuId) => menuId === navItem._id);
        const hasChildren =
            navItem.children &&
            navItem.children.filter((item) => {
                const itemMenu = findMenuItem(menuItem?.children, item);

                if (itemMenu?.type !== '2') {
                    return item;
                }
                return false;
            }).length > 0;
        const isCurrentPath =
            navItem.path === CURRENT_PAGE || navItem.path === location.pathname;

        const expandButton = hasChildren ? (
            <i className="fas fa-angle-left right"></i>
        ) : null;

        const listItemClassName = hasChildren
            ? 'nav-item has-treeview'
            : 'nav-item';
        const titleClassName = `title-depth-${depth}`;
        const isClosing = closing === navItem._id ? 'closing' : '';

        return (
            <li
                key={navItem._id}
                onClick={(event) => {
                    handleOpenSubmenu(
                        event,
                        navItem._id,
                        hasChildren,
                        navItem.path
                    );
                }}
                className={
                    isOpened && hasChildren
                        ? `${listItemClassName} menu-is-opening menu-open ${isClosing}`
                        : `${listItemClassName} ${isClosing}`
                }
            >
                 <a
                    href="#"
                    data-testid={`Menu ${navItem.title}`}
                    className={isCurrentPath ? 'nav-link active d-flex' : 'nav-link d-flex'}
                >
                    <i className={navItem.icon || ''} style={{
                      fontSize: '0.8rem',
                      alignSelf: 'center',
                    }}/>
                    <p
                        className={titleClassName}
                        style={{
                            fontSize: '14px'
                        }}
                    >
                        {navItem.title}
                        {expandButton}
                    </p>
                </a>
                {hasChildren && (
                    <ul
                        className="nav nav-treeview"
                        key={navItem.path}
                        style={{
                            marginLeft: '20px'
                        }}
                    >
                        {navItem.children.map((childItem) => {
                            const itemMenu = findMenuItem(
                                menuItem?.children,
                                childItem
                            );

                            if (itemMenu?.type !== '2') {
                                return (
                                    childItem.canViewMenu && (
                                        <li
                                            className="nav-item"
                                            key={childItem.path}
                                        >
                                            {renderNavItem(
                                                childItem,
                                                itemMenu,
                                                depth + 1
                                            )}
                                        </li>
                                    )
                                );
                            }
                            return null;
                        })}
                    </ul>
                )}
            </li>
        );
    }

    if (menuItem?.type !== '2') {
        return renderNavItem(item, menuItem);
    } else {
        return null;
    }
}

export default NavItem;